import React from "react";

const DataTableFooter = () => {
  

  return (
    <></>
  );
};

export default DataTableFooter;
